(() => {
  try {
    window.swinger.resourceLoader.script(`${window.swinger.config.assetsBase}/detectincognitojs/detectincognitojs.js?v=${window.swinger.config.version}`, () => {
      if (!window.detectIncognito) {
        return;
      }

      window.detectIncognito().then((result) => {
        document.documentElement.classList[result.isPrivate ? 'add' : 'remove']('is-private-mode');

        if (result.isPrivate) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'is-private-mode' });
        }
      });
    })();
  } catch (e) {
    // noop
  }
})();
